import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  salesList: {
    list: {
      data: [],
      total: 0,
    },
  },
  orderData: {
    uplineUserID: '',
    downlineUserID: '',
    orderID: '',
    downlineOrder: false,
    corporateOrder: false,
    isEnrollmentCompleted: false,
  },
  salesCancellationData: {
    userID: '',
    invoiceID: '',
    searchByTaxInvoice: false,
    cancellationID: '',
    searchByCancellationID: false,
  },
  productExchangeData: {
    userID: '',
    invoiceID: '',
    searchByTaxInvoice: false,
    exchangeID: '',
    searchByExchangeID: false,
  },
  selectedFilters: {
    countryID: '',
    filterCountryName: '',
    filterCountryCode: '',
    filterDateRangeFrom: '',
    filterDateRangeTo: '',
    filterTerms: '',
    filterDeliveryMethods: null,
    filterDeliveryStatus: null,
    filterChannel: null,
    filterOrderStatus: null,
    filterDepositRefundType: '',
    filterDepositRefundStatus: '',
  },
  salesProductSearchList: {
    list: {
      data: [],
      total: '0',
    },
  },
  salesInvoiceSearchList: {
    list: [],
  },
  salesInvoiceListing: {
    list: {
      data: [],
      total: 0,
    },
  },
  salesCancellationList: {
    list: {
      data: [],
      total: 0,
    },
  },
  productExchangeList: {
    list: {
      data: [],
      total: 0,
    },
  },
  cartPwpItemsTempList: [],
  cartPwpValidationIds: [],
  paymentOptions: {
    list: [],
  },
  salesData: {},
  salesAddresses: [],
  cartPromotionalRowCurrentStatus: [],
  aeonPaymentList: {
    list: {
      data: [],
      total: 0,
    },
  },
  eppPaymentList: {
    list: {
      data: [],
      total: 0,
    },
  },
  salesExchangeData: {
    data: {},
  },
  eppMotoApprovalResponse: {
    data: {},
  },
  eppMotoRejectionResponse: {
    data: {},
  },
  enrollmentTypeList: {
    list: [],
  },
  cartAdditionalAttributesInCompleteIds: {
    product_ids: [],
    kitting_ids: [],
  },
  enrollmentSalesRankList: {
    list: {
      data: [],
      total: 0,
    },
  },
  saleEligibleApiHasError: {
    error: false,
  },
  eligibleSaleForTransfer: {
    list: [],
  },
  saleTransferData: {},
  saleSvTransfer: {
    itemsInfo: {},
    data: {},
  },
  recordList: {
    list: {
      data: [],
      total: 0,
    },
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
